module.exports = __webpack_public_path__ + "img/lawjudge1.a50f46ef.png";